import { render, staticRenderFns } from "./_CreateConsignes.vue?vue&type=template&id=391c37da&"
import script from "./_CreateConsignes.vue?vue&type=script&lang=ts&"
export * from "./_CreateConsignes.vue?vue&type=script&lang=ts&"
import style0 from "./_CreateConsignes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports